import { handleComponentError } from "../decorators/handleComponentError"
import { FaviconInterface } from "../types/favicon.interface"
import { Component } from "./component"

export class Favicon extends Component<FaviconInterface> {
    setFavicon(url?: string) {
        if (url) {
            ;(this.element as HTMLAnchorElement)!.href = url
        }
    }

    @handleComponentError("Favicon")
    render(): void {
        this.setFavicon(this.props.url)
    }
}
